'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './Introduction.module.scss'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'

interface IntroductionProps {
    data: DataProps
}

interface DataProps {
    _type: string;
    _ref: string;
    textIntro: string;
}

export default function IntroductionComponent({
    data
}: IntroductionProps) {

    return (
        <div className={s.introduction}>
            <h3 dangerouslySetInnerHTML={{__html: data.textIntro}}></h3>
        </div>
    )
}
